<template>
    <l-map id="map" @focus="handleFocus"  @focusout="handleFocusOut" :max-zoom="10" :min-zoom="1" :options="{scrollWheelZoom:scrollWheelZoom}" :zoom="zoom" :center="center" :zoomAnimation="zoomAnimation" :fadeAnimation="fadeAnimation" :markerZoomAnimation="markerZoomAnimation">
      <l-tile-layer
      v-for="tileProvider in tileProviders"
      :key="tileProvider.name"
      :name="tileProvider.name"
      :visible="tileProvider.visible"
      :url="tileProvider.url"
      :attributionControl="false"
      :leafletAttributionControl="false"
      layer-type="base"
    />
    <l-marker v-for="location in airports" v-bind:key="location.airportID" :lat-lng="location.airportCoordinates">
        <l-icon
          :title="location.airportName"
          icon-url="/img/Pointer.svg"
        />
        <l-tooltip
          :content="'✈ ' + location.airportName + ' (' + location.airportIATA + ')'"
        />
    </l-marker>
    <l-marker :lat-lng="[51.907760, 4.476860]">
        <l-icon
          title="Rotterdam"
          icon-url="/img/Pointer-hq.svg"
        />
        <l-tooltip
          content="<div style='font-size:10px;padding-left:10px;padding-right:10px;line-height:5px;'>headquarters</div><br><div style='line-height:5px;padding-left:10px;padding-right:10px; margin-top:-10px !important;'>Rotterdam</div>"
        />
    </l-marker>
  </l-map>
  </template>
  <script>
  import "leaflet/dist/leaflet.css";
  import {LMap, LTileLayer, LControlLayers, LPolyline, LPolygon, LCircle, LCircleMarker, LMarker, LIcon, LGeoJson, LPopup, LTooltip} from 'vue2-leaflet';
  export default {
    components: {
      LMap,
      LTileLayer,
      LControlLayers,
      LPolyline,
      LPolygon,
      LCircle,
      LMarker,
      LGeoJson,
      LPopup,
      LTooltip,
      LCircleMarker,
      LIcon
    },
    mounted: function () {
          this.zoomRatio = 2;
    },
    methods: {
      handleFocus() {

        },
        handleFocusOut() {

        }
    },
    data () {
      return {
        tileProviders: [
        {
          name: 'OSM',
          visible: true,
          url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', //https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png https://tile.openstreetmap.org/{z}/{x}/{y}.png
        }
        ],
        airports: airports,
        zoom: 2,
        zoomAnimation: true,
        fadeAnimation: false,
        markerZoomAnimation: false,
        center: [28,-35],
        zoomRatio: zoomRatio,
        scrollWheelZoom: false
      };
    },
  }
  </script>

<style>
#map {
  background-color: #fff;
  height:400px;
  width:100%;
  border-radius: 5px;
}

.frontend-body #map {
  border-radius: 15px;
  -webkit-box-shadow: 0px 0px 20px -2px rgba(0,0,0,0.3);
  -moz-box-shadow: 0px 0px 20px -2px rgba(0,0,0,0.3);
  box-shadow: 0px 0px 20px -2px rgba(0,0,0,0.3);
  margin-bottom: 40px;
  height: 600px;
  border: 5px solid #f1f1f1;
}

@media all and (max-width: 750px) {
  .frontend-body #map {
    height: 400px;
  }
};

.leaflet-tile-pane {
  -webkit-filter: grayscale(100%);
  filter: grayscale(100%);
  opacity: 0.6;
}

.leaflet-control-attribution {
  display: none;
}

.leaflet-tooltip {
    background-color: #ffd832;
    color: #4b4b4b;
    font-weight: 500;
    border: 0px;
    box-shadow: none;
    border-radius: 2.5rem;
    padding-left: 10px;
    padding-right: 10px;
    font-size: 13px;
    margin-top:-50%;
    font-family: "Telegraf", sans-serif;
}
.leaflet-tooltip-top:before, 
.leaflet-tooltip-bottom:before, 
.leaflet-tooltip-left:before, 
.leaflet-tooltip-right:before {
    border: none !important;
}

.leaflet-bar a {
  background-color: #e4e4e4;
  color: #7e7e7e;
}
</style>